import DatabaseModel from './DatabaseModel.js';

var ComponenteProteccion = Object.create(DatabaseModel);

ComponenteProteccion.model = 'componenteproteccion';
ComponenteProteccion.modelFront = 'componentesproteccion';

export default ComponenteProteccion;